export const ADSR_MAX_TIME_SECONDS = 5

export function timeToNormalized(seconds, maxSeconds = ADSR_MAX_TIME_SECONDS) {
  const value = clamp(Number(seconds) || 0, 0, maxSeconds)
  return Math.log1p(value * 20) / Math.log1p(maxSeconds * 20)
}

export function normalizedToTime(normalized, maxSeconds = ADSR_MAX_TIME_SECONDS) {
  const value = clamp(Number(normalized) || 0, 0, 1)
  return Math.expm1(value * Math.log1p(maxSeconds * 20)) / 20
}

export function sustainToY(sustain, top, bottom) {
  return bottom - clamp(Number(sustain) || 0, 0, 1) * (bottom - top)
}

export function yToSustain(y, top, bottom) {
  return clamp((bottom - Number(y)) / Math.max(1, bottom - top), 0, 1)
}

export function buildAdsrGeometry(adsr, width = 420, height = 128, padding = 14) {
  const top = padding
  const bottom = height - padding
  const phaseWidth = (width - padding * 2) / 4
  const attack = { x: padding + timeToNormalized(adsr.attack) * phaseWidth, y: top }
  const decay = { x: attack.x + timeToNormalized(adsr.decay) * phaseWidth, y: sustainToY(adsr.sustain, top, bottom) }
  const sustain = { x: padding + phaseWidth * 3, y: decay.y }
  const release = { x: sustain.x + timeToNormalized(adsr.release) * phaseWidth, y: bottom }
  return {
    top,
    bottom,
    phaseWidth,
    points: [{ x: padding, y: bottom }, attack, decay, sustain, release],
    attack,
    decay,
    sustain,
    release,
  }
}

export function pointerToAdsr(handle, x, y, adsr, width = 420, height = 128, padding = 14) {
  const geometry = buildAdsrGeometry(adsr, width, height, padding)
  if (handle === 'attack') {
    return { ...adsr, attack: normalizedToTime((x - padding) / geometry.phaseWidth) }
  }
  if (handle === 'decay') {
    return {
      ...adsr,
      decay: normalizedToTime((x - geometry.attack.x) / geometry.phaseWidth),
      sustain: yToSustain(y, geometry.top, geometry.bottom),
    }
  }
  if (handle === 'release') {
    return { ...adsr, release: normalizedToTime((x - geometry.sustain.x) / geometry.phaseWidth) }
  }
  return { ...adsr }
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value))
}
